import React from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'

import range from 'lib/utils/range'

import courseLogic from '~/scenes/course/show/logic'
import I18n from 'lib/i18n'

const DAY_LABELS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map(day => I18n.t(`weekday_short.${day}`))
const DAYS_INDEXES = [1, 2, 3, 4, 5, 6, 0]
const HOUR_GROUPS = range(0, 5)
const HOUR_LABELS = ['00-04', '04-08', '08-12', '12-16', '16-20', '20-24']

function groupBy (matrix, size) {
  return matrix.map(row => {
    const groupedRow = []
    for (let i = 0; i < row.length; i += size) {
      const group = row.slice(i, i + size)
      if (group.includes('1')) {
        groupedRow.push('1')
      } else if (group.includes('2')) {
        groupedRow.push('2')
      } else {
        groupedRow.push('0')
      }
    }
    return groupedRow
  })
}

const Availability = ({ atHome, atTeacher }) => {
  const { course } = useValues(courseLogic)
  const { availabilityInStudio, availabilityInHouse } = course
  const teacherTable = availabilityInStudio.split('|').map(availability => availability.split(','))
  const houseTable = availabilityInHouse.split('|').map(availability => availability.split(','))

  const groupByTeacherTable = groupBy(teacherTable, 4)
  const groupByHouseTable = groupBy(houseTable, 4)

  return (
    <div className='availability-grid-container'>
      {atTeacher && (
        <div className='at-teacher-availability-grid'>
          <div className='cell corner'></div>

          {DAY_LABELS.map(dayLabel => (
            <div key={dayLabel} className='cell label'>
              {dayLabel}
            </div>
          ))}

          {HOUR_GROUPS.map(hourGroup => (
            <React.Fragment key={hourGroup}>
              <div className='cell label group'>{HOUR_LABELS[hourGroup]}</div>
              {DAYS_INDEXES.map(dayIndex => (
                <div
                  key={dayIndex}
                  className={`cell data-cell${parseInt(groupByTeacherTable[dayIndex][hourGroup]) ? ' colored' : ''}`}
                />
              ))}
            </React.Fragment>
          ))}
        </div>
      )}

      {atHome && (
        <div className='at-home-availability-grid'>
          <div className='cell corner'></div>

          {DAY_LABELS.map(dayLabel => (
            <div key={dayLabel} className='cell label'>
              {dayLabel}
            </div>
          ))}

          {HOUR_GROUPS.map(hourGroup => (
            <React.Fragment key={hourGroup}>
              <div className='cell label group'>{HOUR_LABELS[hourGroup]}</div>
              {DAYS_INDEXES.map(dayIndex => (
                <div
                  key={dayIndex}
                  className={`cell data-cell${parseInt(groupByHouseTable[dayIndex][hourGroup]) ? ' colored' : ''}`}
                />
              ))}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
}

Availability.propTypes = {
  atHome: PropTypes.bool,
  atTeacher: PropTypes.bool
}

export default Availability
